'use client';

import { Tabs } from '@base-ui/react/tabs';
import clsx from 'clsx';

import { SDSFlexbox } from '@repo/sds/SDSFlexbox';
import { SDSText } from '@repo/sds/SDSText';

import type { TabCounts } from './HeaderNotificationsSection';

import './NotificationTabs.scss';

export type TabType = 'All' | 'Alerts' | 'Scenarios';

interface NotificationTabsProps {
  selectedTab: TabType;
  onTabChange: (tab: TabType) => void;
  counts?: TabCounts;
  dataTestId?: string;
  tabDataTestIds?: Record<TabType, string>;
}

const TABS: TabType[] = ['All', 'Alerts', 'Scenarios'];

const TAB_COUNT_KEY: Record<TabType, keyof TabCounts> = {
  All: 'all',
  Alerts: 'alerts',
  Scenarios: 'scenarios',
};

export function NotificationTabs({
  selectedTab,
  onTabChange,
  counts,
  dataTestId,
  tabDataTestIds,
}: NotificationTabsProps) {
  return (
    <SDSFlexbox alignItems="center" className="NotificationTabs__feed" fullWidth dataTestId={dataTestId}>
      <Tabs.Root
        value={selectedTab}
        onValueChange={value => onTabChange(value as TabType)}
        className="NotificationTabs__root"
      >
        <Tabs.List className="NotificationTabs__list" activateOnFocus loopFocus>
          {TABS.map(tab => {
            const count = counts?.[TAB_COUNT_KEY[tab]] ?? 0;
            return (
              <Tabs.Tab
                key={tab}
                value={tab}
                data-testid={tabDataTestIds?.[tab]}
                className={clsx('NotificationTabs__tab', {
                  'NotificationTabs__tab--active': selectedTab === tab,
                })}
              >
                <span className="NotificationTabs__tab-content">
                  <SDSText
                    type="body-large"
                    text={tab}
                    className="NotificationTabs__tab-text"
                    color={selectedTab === tab ? 'primary' : 'text-primary'}
                  />
                  {count > 0 && <span className="NotificationTabs__badge">{count}</span>}
                </span>
              </Tabs.Tab>
            );
          })}
        </Tabs.List>
      </Tabs.Root>
    </SDSFlexbox>
  );
}
